import actions from 'actions'

const defaultState = {
  isFetchingEventGroups: true,
  isFetchingSetupforms: true,
}

export default function homePage(state = defaultState, action) {
  switch (action.type) {
    case actions.ENTITIES_EVENT_GROUPS.SUCCESS:
    case actions.ENTITIES_EVENT_GROUPS.FAILURE:
      return {
        ...state,
        isFetchingEventGroups: false,
      }
    case actions.ENTITIES_SETUPFORMS.SUCCESS:
    case actions.ENTITIES_SETUPFORMS.FAILURE:
      return {
        ...state,
        isFetchingSetupforms: false,
      }
    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/pages/home-page/home-page.js
 **/